import { render, staticRenderFns } from "./ReportingInterfaceWrapper.vue?vue&type=template&id=28cae006&scoped=true&"
import script from "./ReportingInterfaceWrapper.vue?vue&type=script&lang=js&"
export * from "./ReportingInterfaceWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ReportingInterfaceWrapper.vue?vue&type=style&index=0&id=28cae006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cae006",
  null
  
)

export default component.exports